import { useMutation, useQueryClient } from '@tanstack/react-query';

import { SizeSettings } from '@air/api';
import { callAirApi } from '@air/utils-api';
import { reportErrorToBugsnag } from '@air/utils-error';

import { getPrivateSizeSetsListKey } from '../usePrivateSizeSetsList';

export type UsePrivateSizeSetsDeleteMutationParams = NonNullable<Parameters<typeof SizeSettings.Sets.delete>[0]>;

export const usePrivateSizeSetsDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: UsePrivateSizeSetsDeleteMutationParams) => {
      return callAirApi<void>(() => SizeSettings.Sets.delete(params));
    },

    onError: (error, variables) => {
      reportErrorToBugsnag({
        context: 'Failed to delete size set',
        error,
        metadata: {
          data: variables,
          key: 'data',
        },
      });
    },

    onSettled: async (_data, _error, variables) => {
      await queryClient.invalidateQueries({
        queryKey: getPrivateSizeSetsListKey({ workspaceId: variables.workspaceId }),
      });
    },
  });
};
